"use client";

import Image from "next/image";
import { Expand, XIcon } from "lucide-react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

// Article screenshot shown full width in a fixed-height frame, cropped from the
// top-left; clicking it opens the full image in a dialog. The close button sits
// in a header row above the image so it never covers UI inside the screenshot.
export function Screenshot({ image }) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          type="button"
          aria-label={`View full image: ${image.alt}`}
          className="group relative mt-4 block h-64 w-full cursor-zoom-in overflow-hidden rounded-xl border border-neutral-200 bg-neutral-50 md:h-80"
        >
          <Image
            src={image.src}
            alt={image.alt}
            width={image.width}
            height={image.height}
            sizes="(min-width: 1024px) 720px, 100vw"
            className="size-full object-cover object-left-top"
          />
          <span className="absolute right-3 bottom-3 flex items-center gap-1.5 rounded-full bg-neutral-900/80 px-3 py-1.5 text-xs font-medium text-white opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100">
            <Expand className="size-3.5" />
            Click to expand
          </span>
        </button>
      </DialogTrigger>
      <DialogContent
        showCloseButton={false}
        className="w-auto max-w-[95vw] gap-2 border-0 bg-white p-2 sm:max-w-[min(1200px,95vw)] sm:rounded-xl"
      >
        <div className="flex items-center justify-between gap-4 pl-2">
          <DialogTitle className="min-w-0 truncate text-sm font-medium text-neutral-600">
            {image.alt}
          </DialogTitle>
          <DialogClose className="flex size-8 shrink-0 items-center justify-center rounded-full text-neutral-500 transition-colors hover:bg-neutral-100 hover:text-neutral-900 focus-visible:ring-2 focus-visible:ring-neutral-400 focus-visible:outline-none">
            <XIcon className="size-5" />
            <span className="sr-only">Close</span>
          </DialogClose>
        </div>
        <Image
          src={image.src}
          alt={image.alt}
          width={image.width}
          height={image.height}
          sizes="95vw"
          className="h-auto max-h-[calc(85vh-3.5rem)] w-auto max-w-full rounded-lg object-contain"
        />
      </DialogContent>
    </Dialog>
  );
}
